module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-vg"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__vidgeo"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "login",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/vidgeo/N0XAiwf.png"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "phone1",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/vidgeo/rARFU1j.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "phone2",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/vidgeo/Qcpv1p8.png",
      "alt": ""
    }
  })])])])])])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Vidgeo\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Personal Project")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("UI & UX"), _c('br'), _vm._v("Front-End")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("2015")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              Vidgeo lets users record videos and pin them onto a location on the map. The idea and initial iOS application build was created during a hackathon. I created the experience and branding, sketched rapid prototypes, and created both low and high-fidelity mocks.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91ffd1de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vidgeo.vue
// module id = 182
// module chunks = 1